import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { useNavigate } from 'react-router-dom';

const ServiceRequestNotAvailablePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={(theme) => ({
          maxWidth: 420,
          width: '100%',
          p: 4,
          textAlign: 'center',
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
          background:
            theme.palette.mode === 'light'
              ? alpha(theme.palette.primary.light, 0.04)
              : alpha(theme.palette.primary.dark, 0.12),
        })}
      >
        <SentimentDissatisfiedIcon
          sx={(theme) => ({
            fontSize: 64,
            color: alpha(theme.palette.text.primary, 0.6),
            mb: 1.5,
          })}
        />

        <Typography variant="h6" fontWeight={700} gutterBottom>
          Service Request Not Available
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          We couldn’t find any active service request matching your selection.
          It may have been completed or removed.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
          onClick={() => navigate('/')}
        >
          Back to Service Requests
        </Button>
      </Paper>
    </Box>
  );
};

export default ServiceRequestNotAvailablePage;
